import { useEffect } from "react";
import api from "../lib/api";

// Lands here after a successful "Sign in with Microsoft" flow. The backend redirects to
// /auth/complete?code=<single-use code> (a query param — survives proxy/ingress redirects, and the
// JWT never appears in the URL). We exchange the code for the JWT, lift it into the app's existing
// localStorage contract (jde_token), scrub the URL, then do a full navigation to "/" so AuthContext
// re-mounts, reads the token and loads the user via /auth/me.
export default function AuthComplete() {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    const bail = (msg) =>
      window.location.replace("/login?ms_error=" + encodeURIComponent(msg));
    if (!code) {
      bail("Microsoft sign-in did not complete.");
      return;
    }
    api
      .get(`/auth/microsoft/exchange?code=${encodeURIComponent(code)}`)
      .then((r) => {
        const token = r.data?.token;
        if (!token) return bail("Microsoft sign-in did not complete.");
        localStorage.setItem("jde_token", token);
        window.history.replaceState({}, document.title, "/auth/complete");
        window.location.replace("/");
      })
      .catch((e) => bail(e.response?.data?.detail || "Microsoft sign-in did not complete."));
  }, []);

  return (
    <div className="jde-login-bg" data-testid="auth-complete">
      <div className="jde-login-card" style={{ padding: 28, textAlign: "center" }}>
        <div style={{ fontSize: 13, color: "var(--omh-text, #333)" }}>Signing you in…</div>
      </div>
    </div>
  );
}
